module.exports = __webpack_public_path__ + "static/media/11.048e7ee9.mp3";